import { createActionsHook, StoreActionApi } from 'react-sweet-state';

import {
  createDataHook,
  createGetAction,
  createLoadingHook,
  createRestActions,
  createRestStore,
  replaceStoreData,
  RestStoreState,
} from '@intelliarts/ia-react-template';

import { turnoverYearlyTrendEnvelopeMapper } from '../turnoverMappers';
import type { TurnoverYearlyDatum, TurnoverYearlyTrendApiResponse } from '../turnoverTypes';

const actionConfig = {
  resourcePath: '/dashboards/turnover/yearly-trend',
};

type TurnoverYearlyTrendState = RestStoreState<TurnoverYearlyDatum>;

const genericActions = createRestActions<TurnoverYearlyDatum>(actionConfig);

const turnoverYearlyTrendActions = {
  ...genericActions,
  loadRange: (fromYear: number, toYear: number) => async ({
    dispatch,
    getState,
  }: StoreActionApi<TurnoverYearlyTrendState>) => {
    const getAction = createGetAction<TurnoverYearlyDatum>({
      ...actionConfig,
      reducer: data => ({ dispatch: d }) => {
        const envelope = (Array.isArray(data) ? data[0] : data) as unknown as TurnoverYearlyTrendApiResponse;
        const points = envelope ? turnoverYearlyTrendEnvelopeMapper.toModel(envelope) : [];
        d(replaceStoreData(points));
      },
    });
    await dispatch(getAction({ params: { fromYear, toYear } }));
    return getState().data;
  },
  clearTurnoverYearlyTrend: () => ({ setState }: StoreActionApi<TurnoverYearlyTrendState>) => {
    setState({ data: [], isLoading: false, changes: [] });
  },
};

export const TurnoverYearlyTrendStore = createRestStore<TurnoverYearlyDatum>({
  actions: turnoverYearlyTrendActions,
  actionConfig,
  containerDisplayName: 'turnover-yearly-trend-container',
  onInitAction: null,
});

export const useTurnoverYearlyTrendData = createDataHook(TurnoverYearlyTrendStore);
export const useTurnoverYearlyTrendIsLoading = createLoadingHook(TurnoverYearlyTrendStore);
export const useTurnoverYearlyTrendActions = createActionsHook(TurnoverYearlyTrendStore);
